var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcLocation = function SvgIcLocation(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58181_137874)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_58181_137874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0195 3C19.645 3.00496 15.451 4.74494 12.3578 7.83822C9.26448 10.9315 7.52449 15.1255 7.51953 19.5C7.51953 33.6187 22.5195 44.2875 23.157 44.7375C23.4125 44.9076 23.7126 44.9984 24.0195 44.9984C24.3265 44.9984 24.6265 44.9076 24.882 44.7375C25.5195 44.2875 40.5195 33.6187 40.5195 19.5C40.5146 15.1255 38.7746 10.9315 35.6813 7.83822C32.588 4.74494 28.3941 3.00496 24.0195 3ZM24.0195 13.5C25.2062 13.5 26.3663 13.8519 27.353 14.5112C28.3397 15.1705 29.1087 16.1075 29.5628 17.2039C30.0169 18.3003 30.1358 19.5067 29.9042 20.6705C29.6727 21.8344 29.1013 22.9035 28.2622 23.7426C27.4231 24.5818 26.354 25.1532 25.1901 25.3847C24.0262 25.6162 22.8198 25.4974 21.7234 25.0433C20.6271 24.5891 19.69 23.8201 19.0307 22.8334C18.3714 21.8467 18.0195 20.6867 18.0195 19.5C18.0195 17.9087 18.6517 16.3826 19.7769 15.2574C20.9021 14.1321 22.4282 13.5 24.0195 13.5Z",
    fill: "#DB147F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0212 1.5L24.0178 1.5C19.246 1.50541 14.6713 3.4034 11.2971 6.77756C7.92293 10.1517 6.02495 14.7265 6.01953 19.4983V19.5C6.01953 27.0825 10.0343 33.6195 13.9581 38.2182C17.9037 42.8423 21.9268 45.7051 22.292 45.963L22.3087 45.9747L22.3257 45.9861C22.8274 46.3201 23.4168 46.4984 24.0195 46.4984C24.6223 46.4984 25.2116 46.3201 25.7133 45.9861L25.7304 45.9747L25.7471 45.963C26.1123 45.7051 30.1353 42.8423 34.0809 38.2182C38.0048 33.6195 42.0195 27.0825 42.0195 19.5V19.4983C42.0141 14.7265 40.1161 10.1517 36.742 6.77756C33.3678 3.4034 28.793 1.50541 24.0212 1.5ZM24.0195 15C24.9095 15 25.7796 15.2639 26.5196 15.7584C27.2596 16.2529 27.8364 16.9557 28.177 17.7779C28.5176 18.6002 28.6067 19.505 28.4331 20.3779C28.2594 21.2508 27.8309 22.0526 27.2015 22.682C26.5722 23.3113 25.7704 23.7399 24.8974 23.9135C24.0245 24.0872 23.1197 23.9981 22.2975 23.6575C21.4752 23.3169 20.7724 22.7401 20.2779 22.0001C19.7835 21.26 19.5195 20.39 19.5195 19.5C19.5195 18.3065 19.9936 17.1619 20.8376 16.318C21.6815 15.4741 22.8261 15 24.0195 15Z",
    stroke: "white",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 19.2031,
    rx: 4,
    ry: 4,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_58181_137874",
    x: 0.519531,
    y: -3,
    width: 47,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.152941 0 0 0 0 0.156863 0 0 0 0 0.2 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_58181_137874"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_58181_137874",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58181_137874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-location.59f20a45.svg";
export { ForwardRef as ReactComponent };